import { useEffect } from 'react'
import { FormState } from 'react-hook-form'
import logger from '_app/utils/logger'
import toast from '_app/utils/toast'

// Temporary solution to allow quicker debugging of the form.
export const useAddressFormErrors = (formState: FormState<any>) => {
  const { errors, isSubmitting } = formState

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENABLE_ADDRESS_FORM_ERRORS !== '1') {
      return
    }

    if (isSubmitting && errors && Object.keys(errors).length) {
      toast(new Error('Something wrong with data. Check console'), {
        isClosable: true,
      })
      logger.error('AddressForm errors', errors)
    }
  }, [errors, isSubmitting])
}
